import { ConfigurableText, NavigationPage } from 'app-components'
import { useNavigation } from '@/app/hooks'
import QRCode from 'react-qr-code'
import { useUrlWithUtilityBasePath } from '@/app/hooks/useUtilityBasePath'
import { logMessage } from '@/logging/sentry'
import { Redirect, useParams } from 'react-router-dom'
import { ButtonContainer } from '@/app/pages/ava/BrandedPage'
import { Button } from '@/components'

export const useViewModel = (props: { vehicleId?: number }) => {
  const { vehicleId } = props
  const navigation = useNavigation()
  const { url: connectionTestUrl, isLoading } = useUrlWithUtilityBasePath(
    `/tesla-authentication/key-confirmation${vehicleId ? `/${vehicleId}` : ''}`,
  )
  const toConnectionTest = () => {
    if (connectionTestUrl) {
      navigation.push(connectionTestUrl)
    } else {
      logMessage(
        'NotOwnerPage: attempt to navigate to connection test failed, no url found',
      )
    }
  }

  return { isLoading, toConnectionTest }
}

export function TeslaOwnerQrPageContent(props: { vehicleId?: number }) {
  const { isLoading, toConnectionTest } = useViewModel(props)

  if (isLoading) {
    return null
  }

  return (
    <>
      <div>
        <div className="flex items-center justify-center mb-5">
          <QRCode
            value={'https://www.tesla.com/_ak/www.optiwatt.com'}
            size={120}
          />
        </div>
        <ConfigurableText variant="body4">
          If you're with the owner, have the owner scan this code to pair
          connection test.
        </ConfigurableText>
      </div>
      <ButtonContainer>
        <Button id="proceed-btn" variant="primary" onClick={toConnectionTest}>
          Ready to proceed
        </Button>
      </ButtonContainer>
    </>
  )
}

export default function TeslaOwnerQrPage() {
  const { vehicleId: vehicleIdParam } = useParams<{ vehicleId: string }>()
  const vehicleId = parseInt(vehicleIdParam)

  if (isNaN(vehicleId)) {
    return <Redirect to="/404" />
  }

  return (
    <NavigationPage
      id="now-owner-no-keycard-page"
      title="Scan the QR Code"
      progressBar={{
        completedSteps: 2,
        totalSteps: 2,
      }}
    >
      <NavigationPage.SingleCardContent>
        <TeslaOwnerQrPageContent vehicleId={vehicleId} />
      </NavigationPage.SingleCardContent>
    </NavigationPage>
  )
}
